 import { useState, useEffect } from 'react';
 import { MarketMaker } from '../apiTypes';
 import {  readElementsMarketMaker } from '../functionApi';
 import { useAxiosInterceptor } from '../wrappers';

 export const useMarketMakerDettaglio = (reportId?: string, componentId?: string, elementId?: string) => {
  useAxiosInterceptor(); // <--- monta l'interceptor
  const [elements, setElements] = useState<MarketMaker[]>([]);
   const [loading, setLoading] = useState(false);
   const [error, setError] = useState<string | null>(null);
 
   useEffect(() => {
     if (!reportId || !componentId || !elementId) return;
 
     const loadElements = async () => {
       setLoading(true);
       try {
         const data = await readElementsMarketMaker(reportId, componentId, elementId); 
         setElements(data);
         setError(null);
       } catch (err) {
         setError('Errore nel caricamento degli elementi');
         console.error(err);
       } finally {
         setLoading(false);
       }
     };
 
     loadElements();
   }, [reportId, componentId, elementId]);
 
   return { elements, loading, error };
 };
 
 

export default useMarketMakerDettaglio
